import React, { ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import FormatService from '../../services/format-service';
import useStylesGridItem from './grid-item.styles';

const GridItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isFullWidth,
    isLargeWidth,
    isMediumWidth,
    isSmallWidth,
    className,
    children,
  } = props;

  const { classes } = useStylesGridItem();

  const fullWidthClassName: string | undefined = isFullWidth ? classes.gridItemFullWidth : undefined;
  const largeWidthClassName: string | undefined = isLargeWidth ? classes.gridItemLargeWidth : undefined;
  const mediumWidthClassName: string | undefined = isMediumWidth ? classes.gridItemMediumWidth : undefined;
  const smallWidthClassName: string | undefined = isSmallWidth ? classes.gridItemSmallWidth : undefined;

  return (
    <Grid
      item
      className={FormatService.formatClassNames(
        fullWidthClassName, largeWidthClassName, mediumWidthClassName, smallWidthClassName, className,
      )}
    >
      {children}
    </Grid>
  );
});

export default GridItem;
